export const FeaturedData = [
    {
        brand_url: "molemab",
        product_url: "surface",
        image: "/images/product_images/molemab_images/molemab_surface/molemab_surface_grinding_1.jpg",
        product_name: "Surface Grinding Wheel (Molemab)",
    },
    {
        brand_url: "cdt",
        product_url: "hybrid_bond",
        image: "/images/product_images/cdt_images/cdt_type_images/CDT-products-hybrid.jpg",
        product_name: "Surface Grinding Wheel (CDT)",
    },
    {
        brand_url: "cdt",
        product_url: "hybrid_bond",
        image: "/images/product_images/cdt_images/cdt_type_images/CDT-products-electro.jpg",
        product_name: "ELECTROPLATED CBN AND DIAMOND TOOLS (CDT)",
    },
    {
        brand_url: "gysl",
        product_url: "lm",
        image: "/images/product_images/gysl_images/gysl_type_images/gysl_lm.jpg",
        product_name: "LM 가이드 연마지석 (GYSL)",
    },
    {
        brand_url: "hirtline",
        product_url: "system_sizes",
        image: "/images/product_images/hirtline_images/hirtline_type_images/hirtline_standard.jpg",
        product_name: "HIRT-LINE NOZZLES",
    },
    {
        brand_url: "innogrind",
        product_url: "standard",
        image: "/images/product_images/innogrind_images/innogrind_type_images/innogrind_standard.jpg",
        product_name: "HIRT-LINE NOZZLES",
    },
    {
        brand_url: "innogrind",
        product_url: "custom",
        image: "/images/product_images/innogrind_images/innogrind_type_images/innogrind_custom.jpg",
        product_name: "HIRT-LINE CUSTOM NOZZLES",
    },
    {
        brand_url: "anicheck",
        product_url: "anicheck",
        image: "/images/product_images/anicheck_images/anicheck_type_images/anicheck.jpg",
        product_name: "ANICHECK",
    },
]